import { Layout } from "@/components";
import type { AppProps } from "next/app";
import React, { FC, useEffect } from "react";
import "../styles/_main.scss";
import "swiper/swiper.min.css";
import { useRouter } from "next/router";

const Root: FC<AppProps> = ({ Component, pageProps }) => {
  const router = useRouter();

  useEffect(() => {
    if (router) {
      (window as any).rewriteLink = (event: Event) => {
        event.preventDefault();

        const el = event.target as HTMLAnchorElement;

        if (
          !el.href.startsWith("http") ||
          el.href.startsWith(
            window.location.href.split("/").slice(0, 3).join("/")
          )
        ) {
          router.push(el.href);
        }
      };
    }
  }, [router]);

  if (pageProps.meta && pageProps.meta.translation) {
    return (
      <Layout {...pageProps}>
        <Component {...pageProps} />
      </Layout>
    );
  }
  return <Component {...pageProps} />;
};

export default Root;
